import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { CheckCircle, XCircle, Loader2 } from 'lucide-react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const VerifyEmail = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('verifying'); // verifying, success, error
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setStatus('error');
      setMessage('Invalid verification link');
      return;
    }

    const verifyEmail = async () => {
      try {
        const response = await axios.get(`${API}/api/verify-email?token=${token}`);
        setStatus('success');
        setMessage(response.data.message || 'Email verified successfully!');
      } catch (error) {
        setStatus('error');
        setMessage(error.response?.data?.detail || 'Verification failed. The link may have expired.');
      }
    };

    verifyEmail();
  }, [searchParams]);

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: '#EEE7D8' }}>
      <div 
        className="max-w-md w-full mx-4 p-8 rounded-lg text-center"
        style={{ backgroundColor: '#F3EEE4', border: '1px solid #D6D0C2' }}
      >
        {status === 'verifying' && (
          <>
            <Loader2 className="h-16 w-16 mx-auto mb-4 animate-spin" style={{ color: '#51120A' }} />
            <h1 
              className="text-2xl font-bold mb-2"
              style={{ fontFamily: "'Instrument Serif', serif", color: '#51120A' }}
            >
              Verifying your email...
            </h1>
            <p style={{ fontFamily: "'Bricolage Grotesque', sans-serif", color: '#875C66' }}>
              Please wait a moment
            </p>
          </>
        )}

        {status === 'success' && (
          <>
            <CheckCircle className="h-16 w-16 mx-auto mb-4" style={{ color: '#22c55e' }} />
            <h1 
              className="text-2xl font-bold mb-2"
              style={{ fontFamily: "'Instrument Serif', serif", color: '#51120A' }}
            >
              Email Verified!
            </h1>
            <p className="mb-6" style={{ fontFamily: "'Bricolage Grotesque', sans-serif", color: '#875C66' }}>
              {message}
            </p>
            <Button
              onClick={() => navigate('/')}
              style={{ 
                backgroundColor: '#51120A', 
                color: 'white', 
                fontFamily: "'Bricolage Grotesque', sans-serif" 
              }}
            >
              Go to Login
            </Button>
          </>
        )}

        {status === 'error' && (
          <>
            <XCircle className="h-16 w-16 mx-auto mb-4" style={{ color: '#ef4444' }} />
            <h1 
              className="text-2xl font-bold mb-2"
              style={{ fontFamily: "'Instrument Serif', serif", color: '#51120A' }}
            >
              Verification Failed
            </h1>
            <p className="mb-6" style={{ fontFamily: "'Bricolage Grotesque', sans-serif", color: '#875C66' }}>
              {message}
            </p>
            <Button
              onClick={() => navigate('/')}
              style={{ 
                backgroundColor: '#51120A', 
                color: 'white', 
                fontFamily: "'Bricolage Grotesque', sans-serif" 
              }}
            >
              Back to Home
            </Button>
          </>
        )}
      </div>
    </div>
  );
};

export default VerifyEmail;
